import i18n, { type ResourceKey } from 'i18next'
import { initReactI18next } from 'react-i18next'

import ar from './locales/ar.json'
import bg from './locales/bg.json'
import en from './locales/en.json'
import es from './locales/es.json'
import ht from './locales/ht.json'
import ptBr from './locales/pt-br.json'
import pt from './locales/pt.json'
import ro from './locales/ro.json'
import sk from './locales/sk.json'
import { type PlatformLanguage } from './utils/types/i18n'

type MainLocale = Record<string, unknown> & {
  dashboard: Record<string, unknown>
  common: Record<string, unknown>
}

const withNamespaces = (translation: MainLocale) => ({
  translation,
  dashboard: translation.dashboard,
  common: translation.common,
})

const resources = {
  en: withNamespaces(en),
  es: withNamespaces(es),
  'pt-BR': withNamespaces(ptBr),
  pt: withNamespaces(pt),
  ht: withNamespaces(ht),
  sk: withNamespaces(sk),
  bg: withNamespaces(bg),
  ro: withNamespaces(ro),
  ar: withNamespaces(ar),
} satisfies Record<PlatformLanguage, ResourceKey>

void i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('language') ?? 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
